import { render, staticRenderFns } from "./MediaSummaryBox.vue?vue&type=template&id=551a0c1b&"
import script from "./MediaSummaryBox.vue?vue&type=script&lang=js&"
export * from "./MediaSummaryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports